import React, { Component } from 'react';
import { Modal, message } from 'antd';
import axios from 'axios';
import Qs from 'qs';
import lodash from 'lodash';
import { api, url } from 'libs/config';
import { krStrTrim, json2formdata } from 'libs/utils';
import MockAdapter from 'axios-mock-adapter';

// mock专用，第一次发起http请求前，将还没有mock的规则放行
let isFirstCallExecuted = false
function firstCallHttp () {
  if (!isFirstCallExecuted) {
    mockCbList.forEach(({ cb, open }) => {
      if (open)
        cb(mock)
    })
    mock.onAny().passThrough()
    isFirstCallExecuted = true
  }
}

//axios实例，包含默认配置
const instance = axios.create({
  baseURL: api.mis,
  withCredentials: true
});

// 生成mock实例
const mock = new MockAdapter(instance);
const mockCbList = []

//接口请求成功的回调
const success = (res, resolve, reject) => {
  if (res.data.code === 0) {
    resolve(res.data.data);
  } else if (res.data.code === 99) {
    let logInDom = document.getElementById('login-dom')
    if (logInDom) logInDom.style.display = 'block'
    // 未登录
    reject(res.data)
  } else if ([4, 5, 6].includes(lodash.get(res, 'data.code'))) { 
    // 4--密码规则不符合要求 5---未修改过密码 6----密码超过90天未修改
    // 来自临时需求http://media-doc.corp.36kr.com/docs/5a7052dd07bc4b4a60c0d431/%E4%B8%B4%E6%97%B6%E9%9C%80%E6%B1%82%20%E4%BC%98%E5%8C%96SSO%E5%AF%86%E7%A0%81%E8%A7%84%E5%88%99-1677587190968/#id=ls937u&p=1_sso%E4%BF%AE%E6%94%B9%E5%AF%86%E7%A0%81
    // 关于5也这样处理是因为后端让5和6同样处理，已反映过需求只说了4、6这样处理。但是结论还是要求5、6同样处理；
    reject(lodash.get(res, 'data.msg'));
    const msg = lodash.get(res, 'data.msg', '');
    const msgArr = msg.split('\r\n');
    const spanStyle = {
      display: 'inline-block',
    }
    const titleSpanStyle = {
      ...spanStyle,
      width: '128px',
      textAlign: 'right'
    }
    Modal.error({
      title: '提示',
      width: 660,
      content: (<div>
        {
          msgArr.map((msgItem, index) => {
            let title = '';
            let content = '';
            if (msgItem.indexOf('：') > -1) {
              let __arr = msgItem.split('：');
              title = __arr[0];
              content = __arr[1].trim();
            } else {
              content = msgItem;
            }
            return (
              <p 
                style={{
                  margin: 0, 
                  lineHeight: 1.4, 
                  marginBottom: index===0 ? '20px': 0,
                  fontSize: index===0 ? '16px': '14px',
                  color: index===0 ? '#262626' : '#787878'
                }}>
                  {title ? <span style={titleSpanStyle}>{title}：</span> : null}
                  <span style={spanStyle}>{content}</span>
              </p>
            )
          })
        }
      </div>),
      okText: '关闭'
    })
  } else if (lodash.get(res, 'data.msg')) {
    reject(res.data);
    if (typeof res.data.msg === 'string' && (res.data.msg.includes('siteId is null'))) {
      const fr = encodeURIComponent(window.location.href);
      window.location.href = `/chosite?fr=${fr}`;
    } else {
      if (res.data.msg !== '登录态为空，请重新登录') message.error(res.data.msg)
    }
  } else {
    reject('系统异常');
    message.error('系统异常');
  }
}

//接口请求失败的回调
const failure = (err, reject, showResponseMessage = false) => {
  const errorMessage = showResponseMessage ? lodash.get(err, 'response.data.msg') : '';
  message.error(errorMessage || '请求异常');
  reject(err);
}

const http = {
  /**
  * 返回一个回调函数，当处于开发环境是，可以激活mock
  */
  setMockRule: (open, cb) => {
    if (process.env.REACT_APP_ENV === 'dev') {
      mockCbList.push({ cb, open })
    }
  },
  /**
   * @param {string} url
   * @param {any} params
   * @param {any} config
   * @param {'json' | 'multipart' | 'tool'} type
   * @param {string} tip
   */
  request: (url, params = {}, config = {}, type = 'json', tip) => {
    return async (dispatch) => {
      dispatch({
        type: 'REQUESTING',
        payload: {
          tip,
        }
      })
      let result
      try {
        if (type === 'json')
          result = await http.json(url, params, config)
        else if (type === 'multipart' || type === 'multiPart')
          result = await http.upload(url, json2formdata({
            param: { ...params }
          }), config)
        else
          throw new Error('未知的请求type')
        dispatch({
          type: 'REQUEST_DONE',
        })
      } catch (e) {
        dispatch({
          type: 'REQUEST_DONE',
        })
      }
      return result
    }
  },
  get: (url, params = {}, config = {}) => {
    firstCallHttp()
    const values = krStrTrim(params);
    const data = {};
    for (let attr in values) {
      data[`param.${attr}`] = values[attr];
    }
    return new Promise((resolve, reject) => {
      instance
        .get(url, { params: data, ...config })
        .then(res => success(res, resolve, reject))
        .catch(err => failure(err, reject));
    });
  },
  post: (url, params = {}, config = {}) => {
    firstCallHttp()
    const values = krStrTrim(params);
    let data = {};
    for (let attr in values) {
      data[`param.${attr}`] = values[attr];
    }
    data = Qs.stringify(data);
    return new Promise((resolve, reject) => {
      instance
        .post(url, data, config)
        .then(res => success(res, resolve, reject))
        .catch(err => failure(err, reject));
    });
  },
  json: (url, params, config = {}) => {
    firstCallHttp()
    let data = { param: {} };
    if (params) {
      const values = krStrTrim(params);
      data = { param: values };
    }
    return new Promise((resolve, reject) => {
      instance
        .post(url, data, config)
        .then(res => success(res, resolve, reject))
        .catch(err => failure(err, reject));
    });
  },
  upload: (url, params = {}, config = {}) => {
    firstCallHttp()
    let data = params;
    return new Promise((resolve, reject) => {
      instance
        .post(url, data, { headers: { 'Content-Type': 'multipart/form-data' }, ...config })
        .then(res => success(res, resolve, reject))

        .catch(err => failure(err, reject, true));
    });
  }
}
export default http
